import ajaxService from '@/services/ajaxService';
import ssoService from '@/services/ssoService';
import store from '@/store/index';

// SSO登入後驗證流程
export function SingleSignOn(to, next) {
  const { companyId, memberSourceId } = store.state;
  const body = { companyId, memberSourceId, code: to.query.code };

  // 組成digest
  return ssoService.getDigest(companyId, memberSourceId, body).toPromise()
    // 用code取得AccessToken
    .then((res) => {
      const header = { digest: res.response.data[0].digest };
      return ssoService.getAccessToken(body, header).toPromise();
    })
    // 驗證AccessToken
    .then((res) => {
      const { accessToken } = res.response.data[0];
      store.commit('set', { name: 'accessToken', value: accessToken });
      return ssoService.verifiyAccesstoken({ accessToken }).toPromise();
    })
    // 登入成功，導頁到活動頁
    .then((res) => {
      const loginbody = {
        companyId,
        memberSourceId,
        memberId: res.response.data[0].memberID,
        memberAcntNo: res.response.data[0].memberAcntNo,
        device: store.state.isMobile ? 'mobile' : 'pc',
      };
      return ssoService.postLogin(loginbody).toPromise().then((res4) => {
        if (res4.response.success) {
          const { code } = res4.response.data[0];

          sessionStorage.setItem('code', code);
          sessionStorage.setItem('memberId', res.response.data[0].memberID);
          sessionStorage.setItem('memberAcntNo', res.response.data[0].memberAcntNo);

          store.commit('set', { name: 'memberId', value: res.response.data[0].memberID });

          // 導頁到CallBack頁
          next({ name: 'CallBack', params: to.params });
        }
      });
    })
    // 發生錯誤，導頁到錯誤頁
    .catch(() => { next({ name: 'Error' }); });
}

// LineLogin登入後驗證流程 (pending，未測試)
export function LineLogin(code, next) {
  const comUrl = JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_API_COM_URL}' : process.env.VUE_APP_API_COM_URL;
  const companyId = JSON.parse(process.env.VUE_APP_LINE_LOGIN_COMPANY_ID) ? '${VUE_APP_LINE_LOGIN_COMPANY_ID}' : process.env.VUE_APP_LINE_LOGIN_COMPANY_ID;
  const directUrl = window.location.href;

  // 用code取得Line會員資訊
  return ajaxService.post(`${comUrl}api/v1/lineuserid`, { code, companyId, directUrl }).toPromise()
    // 登入成功，取得活動資料
    .then((res) => {
      store.commit('set', { name: 'memberId', value: res.response.data[0].userID });
      return store.dispatch('getActivity');
    })
    // 依據活動資料決定要導頁到活動頁或是資料填寫頁
    .then((activity) => {
      // TODO 導頁到資料填寫頁
      if (activity.isFillinForm) next({ name: '' });
      // TODO 導頁到活動頁
      next({ name: '' });
    })
    // 發生錯誤，導頁到錯誤頁
    .catch(() => { next({ name: 'Error' }); });
}
